import { StructureSearchSession } from '@/pages/User/pages/Home/components/StructureSearchPanel/searchPanelUi'

import { State } from '.'
import { UPDATE_SETTINGS, UPDATE_STRUCTURE_SEARCH } from './constants'

interface UpdateSettings {
	payload: State
	type: typeof UPDATE_SETTINGS
}

interface UpdateStructureSearch {
	payload: Partial<StructureSearchSession>
	type: typeof UPDATE_STRUCTURE_SEARCH
}

export const updateSettings = (opts: State): UpdateSettings => ({
	type: UPDATE_SETTINGS,
	payload: opts,
})

export const updateStructureSearch = (
	payload: Partial<StructureSearchSession>,
): UpdateStructureSearch => ({
	type: UPDATE_STRUCTURE_SEARCH,
	payload,
})

export type Actions = UpdateSettings | UpdateStructureSearch
